/**
 * Render a generation request as a copy-paste cURL command — a test-bench affordance so a tester
 * can reproduce a generation outside the UI. The Bearer is a placeholder (the real token is the
 * signed-in admin's); the URL is the full gateway path.
 */
export function toCurl(url: string, body: unknown): string {
  return [
    `curl -X POST '${url}'`,
    `-H 'Content-Type: application/json'`,
    `-H 'Authorization: Bearer <your-token>'`,
    `-d '${JSON.stringify(body)}'`,
  ].join(" \\\n  ");
}
